import React from "react"
import { FormattedMessage } from "react-intl"
import { Link } from "react-router-dom"
import Icon from "../../../icon/icon.component.jsx"

const BundleCreationButton = () => {
    return (
        <>
            <Link to="/bundles/new" className="btn btn-primary">
                <Icon value="plus-circle" />
                <FormattedMessage
                    id="generic-listing.bundles.create-btn-text"
                    defaultMessage="New Bundle"
                />
            </Link>
        </>
    )
}

export default BundleCreationButton



// WEBPACK FOOTER //
// ./src/common/listing/generic-listing/creation-buttons/BundleCreationButton.tsx